import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective, TabsModule } from 'ngx-bootstrap';
import { Subscription } from 'rxjs/Subscription';

import { DataService } from '../../../services/data.service';

@Component({
	selector: 'app-gestisci-flussi',
	templateUrl: './gestisci-flussi.component.html',
	styleUrls: ['./gestisci-flussi.component.css']
})
export class GestisciFlussiComponent implements OnInit {
	@Input() writePermission: boolean = false;
	@Output() innerEvents = new EventEmitter();

	selected: any;
	active: any;

	flowsSync: Subscription;
	flows: any[] = [];
	utilizzabili: any[] = [];
	obsoleti: any[] = [];

	constructor(private dataService: DataService) {}

	ngOnInit() {
		console.log('GESTISCI FLUSSI INIT');
		this.flowsSync = this.dataService.flows$.subscribe(
			flows => {
				this.organize(flows);
			});
	}

	organize(flows: any) {
		this.utilizzabili = [];
		this.obsoleti = [];
		for (let flow of flows) {
			if ( flow.obsoleto == '1' ) {
				this.obsoleti.push(flow);
			}
			else {
				if (flow.attivo == '1') {
					this.selected = flow.id;
					this.active = flow.id;
				}
				this.utilizzabili.push(flow);
			}
		}
	}

	hide(){
		let event:any = {
			hide : true
		}
		this.innerEvents.emit(event);
	}

	discard() {
		this.hide();
	}

	save() {
		let localFilters = [];
		if (this.selected != this.active) {
			localFilters.push({ type: "=", key: "id", value: this.selected });

			this.dataService.update('flussi_pratica', localFilters, { attivo: 1 }, true, (error,res) => {
				if (error) {
					console.log('ERRORE 1',error);
				}
				else {
					localFilters = [];
					localFilters.push({ type: "=", key: "id", value: this.active });
					this.dataService.update('flussi_pratica', localFilters, { attivo: -1 }, true, (error,res) => {
						if (error) {
							console.log('ERRORE 1',error);
						}
						else {
							this.hide();
						}
					});
				}
			});
		}
		else {
			this.hide();
		}
	}

	removeFlow(id: any) {
		console.log('removeFlow', id);
		let localFilters = [];
		localFilters.push({ type: "=", key: "id", value: id });

		this.dataService.delete("flussi_pratica", localFilters, true, (error,res) => {
			if (error) {
				//this.dataService.openMessage('ELIMINAZIONE FLUSSO','si è verificato un errore');
			}
		});
	}

	updateFlow(id: any) {
		console.log('updateFlow', id);
	}

	checkSelected() {
		console.log(this.selected, this.active);
	}

	isDefaultFlow(flow: any) {
		return flow.comune_id == null;
	}
}
